import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackViewedLoginPage = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedLoginPage = useCallback(() => {
    track(`Viewed login page`);
  }, [track]);

  return { trackViewedLoginPage };
};
